import moment from "moment-timezone";

export const YMD = "YYYY-MM-DD";
export const YMDHMS = "YYYY-MM-DD HH:mm:ss";

export const DMY = "DD.MM.YYYY";

export const isDMY = (str = "") => {
  const m = moment(str, "DD/MM/YYYY");
  return m.isValid();
};

export const isDMYHIS = (str = "") => {
  const m = moment(str, "DD/MM/YYYY HH:mm:ss");
  return m.isValid();
};

export const dmy2ymd = (str = "", defaultValue = "") => {
  const m = moment(str, "DD/MM/YYYY");
  return m.isValid() ? m.format("YYYY-MM-DD") : defaultValue;
};

export const dmy2ymdhis = (str = "", defaultValue = "") => {
  const m = moment(str, "DD/MM/YYYY");
  return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : defaultValue;
};

export const dmyhis2ymdhis = (str = "", defaultValue = "") => {
  const m = moment(str, "DD/MM/YYYY HH:mm:ss");
  return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : defaultValue;
};

export const ymd2Nature = (str = "", defaultValue = "") => {
  const m = moment(str, "YYYY-MM-DD");
  return m.isValid() ? m.format("Do MMM, YYYY") : defaultValue;
};

export const ymd2dmy = (str = "", defaultValue = "") => {
  const m = moment(str, "YYYY-MM-DD");
  return m.isValid() ? m.format("DD/MM/YYYY") : defaultValue;
};

export const ymdhis2dmy = (str = "", defaultValue = "") => {
  const m = moment(str, "YYYY-MM-DD HH:mm:ss");
  return m.isValid() ? m.format("DD/MM/YYYY") : defaultValue;
};

export const ymdhis2dmyhis = (str = "", defaultValue = "") => {
  const m = moment(str, "YYYY-MM-DD HH:mm:ss");
  return m.isValid() ? m.format("DD/MM/YYYY HH:mm:ss") : defaultValue;
};

export const ymdhis2utc = (str = "", defaultValue = "") => {
  const m = moment(str, "YYYY-MM-DD HH:mm:ss");
  return m.isValid() ? m.utc() : defaultValue;
};

export const utc2dmyhis = (str = "", defaultValue = "") => {
  const m = moment.utc(str);
  return m.isValid() ? m.format("DD/MM/YYYY HH:mm:ss") : defaultValue;
};

export const todmyhis = (str = "", defaultValue = "") => {
  const m = moment.utc(str, "YYYY-MM-DD HH:mm:ss");
  return m.isValid() ? m.format("DD/MM/YYYY HH:mm:ss") : defaultValue;
};

export const age = (str = "") => {
  if (!Number(String(str).substr(0, 4))) {
    return "";
  }
  return new Date().getFullYear() - Number(String(str).substr(0, 4)) + " y.o";
};

export const curWeekNum = moment().isoWeek();

export const curYearNum = moment().isoWeekYear();

export const weekCount = moment().isoWeeksInISOWeekYear();

export const getStartDate = () =>
  moment.tz("Pacific/Auckland").clone().startOf("month");
export const getEndDate = () =>
  moment.tz("Pacific/Auckland").clone().endOf("month");

export const getDayName = (dayNum = 1) => {
  if (+dayNum === 1) return "Monday";
  if (+dayNum === 2) return "Tuesday";
  if (+dayNum === 3) return "Wednesday";
  if (+dayNum === 4) return "Thursday";
  if (+dayNum === 5) return "Friday";
};

export const getWeekDaysByWeekNumber = ({
  weekNumber = 1,
  addDay = 0,
  format = "ddd DD MMM",
  yearNumber = curYearNum,
}) => {
  return moment()
    .isoWeek(weekNumber)
    .isoWeekYear(yearNumber)
    .startOf("isoWeek")
    .add(addDay, "day")
    .format(format);
};

export const getWeekDateByWeekNumber = (
  weeknumber = 1,
  addDay = 0,
  yearNumber = curYearNum
) => {
  return moment()
    .isoWeek(weeknumber)
    .isoWeekYear(yearNumber)
    .startOf("isoWeek")
    .add(addDay, "day")
    .toDate();
};
export const getWeekDate = ({
  weekNumber = 1,
  addDay = 0,
  yearNumber = curYearNum,
}) =>
  moment()
    .isoWeek(weekNumber)
    .isoWeekYear(yearNumber)
    .startOf("isoWeek")
    .add(addDay, "day");

export const getDateByTimestamp = ({
  timevalue = "",
  format = "ddd DD MMM",
}) => {
  return moment.unix(timevalue).format(format);
};
